import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=92475fae&"
import script from "./Btn.vue?vue&type=script&lang=js&"
export * from "./Btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports